export default __webpack_public_path__ + "static/media/water.8e3d140b.jpg";